<template>
  <div class="wrap">
    <div class="boxCard">
      <el-card class="box-card" :body-style="{padding: '0'}">
        <div slot="header" class="clearfix">
          <span>banner管理</span>
        </div>
        <el-form :inline="true" :model="queryParams" ref="queryParams" class="demo-form-inline">
          <el-form-item label="活动名称" prop="activitiyName">
            <el-input v-model="queryParams.activitiyName" placeholder="请输入会员姓名"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="releaseStatus">
            <el-select v-model="queryParams.releaseStatus" placeholder="请选择状态">
              <el-option label="全部" value="" />
              <el-option label="已发布" value="1" />
              <el-option label="未发布" value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="类型" prop="advertisementType">
            <el-select v-model="queryParams.advertisementType" placeholder="请选择类型">
              <el-option label="全部" value="" />
              <el-option label="小程序页面" value="1" />
              <el-option label="无链接广告" value="2" />
              <el-option label="H5页面" value="3" />
            </el-select>
          </el-form-item>
          <el-form-item label="时间" prop="date">
            <el-date-picker v-model="date" @change="onChangeDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetQuery">查询</el-button>
            <el-button @click="resetForm('queryParams')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
    <div class="boxCard">
      <el-card class="box-card" :body-style="{padding: '0'}">
        <div slot="header">
          <span class="tabTitle">banner列表</span>
          <el-button type="primary" @click="add">新增</el-button>
        </div>
        <el-table :data="tableData" show-header border style="width: 100%">
          <el-table-column type="index" align="center" label="序号" />
          <el-table-column prop="activitiyName" align="center" label="活动名称" />
          <el-table-column label="banner图" align="center">
            <template slot-scope="scope">
              <el-image style="width:80px;" @click.stop="handleClickItem" :src="scope.row.activitiyPictureUrl" :preview-src-list="[scope.row.activitiyPictureUrl]"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="advertisementType" :formatter="advertisementTypeFormat" align="center" label="banner类型" />
          <!-- <el-table-column label="banner类型" align="center"  :formatter="pickWaysFormat">
                    <template slot-scope="scope">{{getBannerType(scope.row.advertisementType)}}</template>
                </el-table-column> -->
          <el-table-column prop="createTime" align="center" label="发布时间" />
          <el-table-column prop="a" align="center" label="状态">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.releaseStatus" @change="onChangeSwitch(scope.row)" :active-value="1" :inactive-value="2" />
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="150">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
              <el-button size="mini" type="success" @click="edit(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="pageNum" :page-size="pageSize" @size-change="barSizeChange" @current-change="barCurrentChange" :page-sizes="[10, 20, 30, 40, 50]" background="" layout="sizes, prev, pager, next" :total="totalCount"></el-pagination>
      </el-card>
    </div>

    <my-from-dialog :isShow="isShowDiaFlag" :title="diaTitle" @cancel="closePup" @ok="closePup('ok')" @closeCallBack="closePup" :isFullscreen="false" :scrollHeight="'400px'" :dialogWidth="'800px'" :okBtnText="'保 存'" :cancelBtn="true" :okBtn="true">
      <template slot="froms">
        <el-form label-width="140px" :model="bannerForm" :rules="rules" ref="rules">
          <el-form-item label="活动名称" style="width:50%" prop="activitiyName">
            <el-input v-model="bannerForm.activitiyName"></el-input>
          </el-form-item>
          <el-form-item label="图片" prop="activitiyPictureUrl">
            <myUpload @getImgUrl="getImgUrl" :imgUrls="bannerForm.activitiyPictureUrl" />
          </el-form-item>
          <el-form-item label="广告类型" prop="advertisementType">
            <el-radio-group v-model="bannerForm.advertisementType" @change="onChangeRadio">
              <el-radio :label="1">链接广告</el-radio>
              <el-radio :label="2">无链接广告</el-radio>
              <el-radio :label="3">H5页面</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="bannerForm.advertisementType === 1 || bannerForm.advertisementType === 3" label="页面链接" style="width:70%" prop="advertisementUrl">
            <el-input v-model="bannerForm.advertisementUrl"></el-input>
          </el-form-item>
          <!-- <el-form-item label="发布时间">
                  <el-date-picker v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                  </el-date-picker>
              </el-form-item> -->
          <el-form-item label="发布状态">
            <el-switch v-model="bannerForm.releaseStatus" :active-value="1" :inactive-value="2" />
          </el-form-item>
        </el-form>
      </template>
    </my-from-dialog>
  </div>
</template>

<script>
import myFromDialog from '@/components/common/from_dialog';
import { objDeepCopy, resDecPoint, getDate } from '@/utils/index';
import myUpload from '@/components/common/upload';

let self = null;
export default {
  components: { myFromDialog, myUpload },
  computed: {},
  watch: {},
  created() {
    this.loginData = JSON.parse(localStorage.getItem('loginData')) || {};
    self = this;
    this.getBannerList();
  },
  data() {
    return {
      isShowDiaFlag: false,
      queryParams: { // 查询条件表单
        activitiyName: '', // 活动名称
        releaseStatus: '', // banner类型
        advertisementType: '', // 状态
      },
      date: '', // 创建时间
      // ================================= 分页 -s
      pageNum: 1,
      pageSize: 10,
      totalCount: 0,
      // ================================= 分页 -e
      tableData: [], // 列表数据
      diaTitle: '新增',
      bannerForm: this.getInitFormData(),
      rules: this.getRules()
    }
  },
  methods: {
    resetQuery() { // 查询
      this.pageNum = 1;
      this.pageSize = 10;
      this.getBannerList();
    },
    resetForm(formName) { // 表单重置
      self.date = '';
      self.queryParams.beginTime = '';
      self.queryParams.endTime = '';
      this.$refs[formName].resetFields();
      this.getBannerList();
    },
    // =================================================================================== 分页 -s
    barSizeChange(val) { // 当前显示条数
      this.pageSize = val;
      this.getBannerList();
    },
    barCurrentChange(val) { // 当前页
      this.pageNum = val;
      this.getBannerList();
    },
    // =================================================================================== 分页 -e
    closePup(state) { // 关闭弹窗
      if (state === 'ok') {
        self.save();
      } else {
        self.isShowDiaFlag = false;
      }
    },
    onChangeRadio(val) {
      console.log(val)
      console.log(this.bannerForm.advertisementType);
      // this.form.advertisementType = val;
    },
    getImgUrl(url) {
      console.log(url);
      this.bannerForm.activitiyPictureUrl = url;
    },
    del(row) {
      this.$alert(`是否删除 “${row.activitiyName}”活动`, '提示', {
        confirmButtonText: '确定',
        callback: action => {
          console.log(action);
          if (action == 'confirm') {
            self.$https.get('system/bannerInfo/deleBannerInfoById', { id: row.id }).then(res => {
              if (res.code === 200) {
                self.$message.success('删除成功!');
                self.getBannerList();
              }
            }).catch(res => {
              // self.$message.error(res.data.msg || '接口请求异常');
            })
          }
        }
      });
    },
    add() {
      self.isShowDiaFlag = true;
      self.diaTitle = '新增';
      self.bannerForm = {};
    },
    edit(rows) {
      this.isShowDiaFlag = true;
      this.diaTitle = '编辑';
      Object.assign(self.bannerForm, rows);
    },
    getSavaParams() { // 获取保存参数
      let flag = false;
      self.$refs.rules.validate(valid => { flag = valid });
      if (!flag) return false;
      if (self.bannerForm.advertisementType == 2) {
        self.bannerForm.advertisementUrl = '';
      }
      let params = self.bannerForm;
      params.enterpriseId = self.loginData.enterpriseId;
      params.bannerType = 1; // 小程序类型1 终端2
      return params;
    },
    save() {
      let url = self.diaTitle == '编辑' ? 'system/bannerInfo/updateBannerById' : 'system/bannerInfo/insertBannerInfo';
      self.$https.post(url, self.getSavaParams()).then(res => {
        if (res.code === 200) {
          self.getBannerList();
          self.isShowDiaFlag = false;
          self.$message.success('保存成功');
        }
      }).catch(res => {
        // self.$message.error(res.data.msg || '接口请求异常');
      })
    },
    // 日期
    onChangeDate(date) {
      console.log(date)
      // console.log(getDate('-', date[0], false))
      if (date) {
        self.queryParams.beginTime = getDate('-', date[0], false) + ' 00:00:00';
        self.queryParams.endTime = getDate('-', date[1], false) + ' 23:59:59';
      } else {
        self.queryParams.beginTime = '';
        self.queryParams.endTime = '';
      }
    },
    getQueryParams() { // 获取请求参数
      let params = {};
      Object.assign(params, self.queryParams, {
        pageNum: self.pageNum,
        pageSize: self.pageSize,
        enterpriseId: this.loginData.enterpriseId
      });
      console.log(params);
      return params;
    },
    // 获取列表
    getBannerList() {
      self.$https.get('system/bannerInfo/getBannerInfo', self.getQueryParams()).then(res => {
        if (res.code === 200) {
          self.tableData = res.data.records || [];
          self.totalCount = res.data.total || 0;
        }
      }).catch(res => {
        // self.$message.error(res.data.msg || '接口请求异常');
      })
      // getBanner(this.searchForm).then(res => {
      //     console.log(res);
      //     if (res.code == 200) {
      //         this.orderData = res.data.records;
      //         this.total = res.data.total;
      //     }
      //     this.loading = false;
      // })
    },
    // banner状态修改
    onChangeSwitch(val) {
      console.log(val)
      let content = '';
      let status = null;
      if (val.releaseStatus === 2) {
        content = '确定要停用该banner图吗';
        status = 2;
      } else {
        content = '确定要启用该banner图吗';
        status = 1;
      }
      let params = {
        id: val.id,
        status: status
      }
      this.$confirm(content, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.$https.get('system/bannerInfo/updateBannerStatus', params).then(res => {
          if (res.code === 200) {
            self.$message.success('修改成功!');
            self.getBannerList();
          }
        }).catch(res => {
          // self.$message.error(res.data.msg || '接口请求异常');
        })
      });
    },
    advertisementTypeFormat(row, column) {
      return {
        1: '链接广告',
        2: '无链接广告',
        3: 'H5页面'
      }[row.advertisementType] || ''
    },
    getInitFormData() {
      return {
        activitiyName: '', //活动名称
        activitiyPictureUrl: '', //图片
        advertisementType: '', //广告类型
        advertisementUrl: '', //页面链接
        releaseStatus: '', //发布状态
      }
    },
    getRules() {
      return {
        activitiyName: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
        activitiyPictureUrl: [{ required: true, message: '请上传图片', trigger: 'change' }],
        advertisementType: [{ required: true, message: '请选择广告类型', trigger: 'change' }],
        advertisementUrl: [{          required: true, validator: (rule, value, callback) => {
            if (this.bannerForm.advertisementType !== 2) {
              if (!value) {
                return callback(new Error('请输入页面链接'))
              } else {
                callback();
              }
            } else {
              callback();
            }
          }, trigger: 'blur'        }]
      }
    }
  },
}
</script>

<style lang="less" scoped>
.boxCard {
    margin-bottom: 20px;
}
.tabTitle {
    color: #333;
    font-size: 15px;
    font-weight: bold;
    margin-right: 30px;
}
</style>
